import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { PrimaryTrade } from './primary-trade';
import { TradeCategory } from './trade-category';

export class TradeSpecialtyCategory extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static TradeSpecialtyCategoryProperties: (
    | {
        property: keyof TradeSpecialtyCategory;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof TradeSpecialtyCategory;
        type: 'alias';
      }
    | {
        property: keyof TradeSpecialtyCategory;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'TradeCategoryId', type: 'column', dataType: 'number' },
    { property: 'PrimaryTradeId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'TradeCategory', model: 'TradeCategory', type: 'association' },
    { property: 'PrimaryTrade', model: 'PrimaryTrade', type: 'association' }
  ];

  static {
    TradeSpecialtyCategory.TradeSpecialtyCategoryProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          TradeSpecialtyCategory.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          TradeSpecialtyCategory.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          TradeSpecialtyCategory.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(TradeSpecialtyCategoryObject: Partial<TradeSpecialtyCategory>) {
    super();

    TradeSpecialtyCategory.TradeSpecialtyCategoryProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = TradeSpecialtyCategoryObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  TradeCategoryId?: number;
  PrimaryTradeId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  TradeCategory?: TradeCategory;
  PrimaryTrade?: PrimaryTrade;

  //TradeCategory
  //PrimaryTrade
}
